import {
  GET_ADD_ON_SERVICE,
  GET_ADD_ON_SERVICE_FAILURE,
  GET_ADD_ON_SERVICE_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAddOnServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADD_ON_SERVICE:
      return { ...state, loading: true };
    case GET_ADD_ON_SERVICE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_ADD_ON_SERVICE_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAddOnServiceReducer;
